// Import this first so that placeholders for inject-build-params.sh live in entrypoint bundle
import '@monument/core/config/env';

import React from 'react';
import ReactDOM from 'react-dom';
import { resolveRender } from '@monument/core';
import { App } from './App/App';

// Legacy global styles
import '@monument/core/styles/monument.less';

// Styles used by app + core
import './tailwind.build.css';

// polyfill for replaceAll which is used in Stream chat source code, still barely supported, see
// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
import 'core-js/features/string/replace-all';

import '@monument/core/polyfills/buffer';

resolveRender(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
